module.exports = __webpack_public_path__ + "static/Payer-9b9ea162d42e70ce32f485dfb83cfc28.jpg";